import { reactive } from "vue";

const savedWidth = localStorage.getItem("contentWidth") || "fluid";

const config = reactive({
    themeName: "Metronic",
    themeVersion: "8.0.29",
    demo: "demo1",
    main: {
        type: "dark",
        primaryColor: "#0C2C55",
        logo: {
            dark: "/logo/neptuniva-logo.svg",
            light: "/logo/neptuniva-logo-light.svg",
        },
    },
    loader: {
        logo: "/media/logos/logo-1-dark.svg",
        display: true,
        type: "default",
    },
    scrollTop: {
        display: true,
    },
    header: {
        display: true,
        menuIcon: "font",
        width: "fluid",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    toolbar: {
        display: true,
        width: "fluid",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    aside: {
        display: true,
        theme: "dark",
        fixed: true,
        menuIcon: "svg",
        minimized: false,
        minimize: true,
        hoverable: true,
    },
    content: {
        width: savedWidth,
    },
    footer: {
        width: "fluid",
    },
});

export default config;
